import React, { ComponentProps } from 'react';
import { Route, withRouter, RouteComponentProps } from 'react-router-dom';

import { fomatParentPath } from '../../utils';
import { MobSubscribeTransfer } from '../../lib';

function RouteMobSubscribeTransfer(props: RouteComponentProps & ComponentProps<any>) {
  const parentPath: string = fomatParentPath(props);
  return (
    <Route weId={`${props.weId || ''}_pb8iga`} path={`${parentPath}/mobile/uk/subscribe/:module/:targetId`}>
      {
        <MobSubscribeTransfer weId={`${props.weId || ''}_kj0za7`}/>
      }
    </Route>
  )
}

export default withRouter(RouteMobSubscribeTransfer);